import { clsx } from '@mantine/styles'

import aiIcon from '../../../assets/icons/reward-stars-3.svg'
import classes from './ai-box.module.scss'
import { AiBoxProps } from './ai-box.types'

function AiBoxContent({
  children,
  headerRow,
  withIcon,
}: Pick<AiBoxProps, 'children' | 'headerRow' | 'withIcon'>) {
  if (headerRow && withIcon) {
    return (
      <>
        <div className={clsx(classes.aiBoxInner, classes.withHeaderRow)}>
          <img src={aiIcon} alt="AI" />
          {headerRow}
        </div>
        {children}
      </>
    )
  }

  if (headerRow) {
    return (
      <>
        {headerRow}
        {children}
      </>
    )
  }

  if (withIcon) {
    return (
      <div className={classes.aiBoxInner}>
        <img src={aiIcon} alt="AI" />
        {children}
      </div>
    )
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment -- this Fragment is for typechecking purposes
  return <>{children}</>
}

export function AiBox({
  children,
  className,
  withIcon,
  headerRow,
  ...props
}: AiBoxProps) {
  return (
    <div className={clsx(classes.aiBox, className)} {...props}>
      <AiBoxContent withIcon={withIcon} headerRow={headerRow}>
        {children}
      </AiBoxContent>
    </div>
  )
}
